import React, { memo } from "react";
import { View } from "react-native";
import StatsCard, { type IconProps } from "./stats-card";

type StatItem = Readonly<{
  count: number;
  text: string;
  icon: React.ReactElement<IconProps>;
}>;

type StatsRowProps = Readonly<{
  stats: ReadonlyArray<StatItem>;
}>;

const StatsRow = ({ stats }: StatsRowProps) => {
  return (
    <View className="flex-row justify-center gap-2 flex-wrap md:flex-1 md:flex-nowrap md:rounded-2xl md:border md:border-ash-3 bg-chalk md:p-6">
      {stats.map((statItem) => (
        <StatsCard
          key={statItem.text}
          count={statItem.count}
          text={statItem.text}
          icon={statItem.icon}
        />
      ))}
    </View>
  );
};

export default memo(StatsRow);
